import React, { Component } from "react";
import MyNavbar from "../../components/Navbar/MyNavbar";
import UserRegistration from "../../components/user/UserRegistration/UserRegistration";

export default class UserRegistrationPage extends Component {
  render() {
    return (
      <div>
        <MyNavbar />
        <UserRegistration />
      </div>
    );
  }
}
